function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFuelConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#B1CBD9",
    style: {
      fill: "#B1CBD9",
      fill: "color(display-p3 0.6941 0.7961 0.8510)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#D0E0E8",
    style: {
      stroke: "#D0E0E8",
      stroke: "color(display-p3 0.8157 0.8784 0.9098)",
      strokeOpacity: 1
    },
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6533 26.0934C34.4557 24.8114 35.0245 23.3973 35.3333 21.9167C35.9167 24.8334 37.6667 27.6334 40 29.5001C42.3333 31.3667 43.5 33.5834 43.5 35.9167C43.5067 37.5294 43.0343 39.1078 42.1429 40.4517C41.2515 41.7956 39.9811 42.8446 38.4928 43.4657C37.0045 44.0867 35.3653 44.2519 33.783 43.9402C32.2007 43.6286 30.7466 42.8541 29.605 41.7151M27.1667 37.4101C29.7333 37.4101 31.8333 35.2751 31.8333 32.6851C31.8333 31.3317 31.1683 30.0484 29.8383 28.9634C28.5083 27.8784 27.505 26.2684 27.1667 24.5767C26.8283 26.2684 25.8367 27.8901 24.495 28.9634C23.1533 30.0367 22.5 31.3434 22.5 32.6851C22.5 35.2751 24.6 37.4101 27.1667 37.4101Z",
    stroke: "#365A6D",
    style: {
      stroke: "#365A6D",
      stroke: "color(display-p3 0.2118 0.3529 0.4275)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelConfig);
export default __webpack_public_path__ + "static/media/fuelConfig.14e4d2740c4afcee3ea2662dc16bd033.svg";
export { ForwardRef as ReactComponent };